/**
 * Dependencies
 */
import Choices from 'choices.js';

export default {
    props: ['default-sort', 'meta'],

    data() {
        return {
            sortBy: '',
            options: null,
        };
    },

    computed: {
        showSort() {
            // Does meta exist?
            return !!this.meta;
        },
    },

    mounted() {
        // Set property with prop
        this.sortBy = this.defaultSort;

        // Set property with hard coded options
        this.options = [
            { label: 'Alphabetical', value: 'alphabetical', selected: this.sortBy === 'alphabetical' },
            { label: 'Product Count', value: 'productCount', selected: this.sortBy === 'productCount' },
        ];

        // Initiate Choices.js
        return new Choices(this.$el.querySelector('select'), {
            searchEnabled: false,
            choices: this.options,
            itemSelectText: '',
        });
    },

    watch: {
        sortBy(value) {
            // Emit to parent
            this.$emit('sort-manufacturers', value);
        },
    },

    template: `
        <div v-show="showSort" class="products-filter">
            <label>Sort by</label>
            <select class="dropdown dropdown--icon-circle-chevron" v-model="sortBy"></select>
        </div>
    `,
};
